import { MakeCall } from './createMakeCall';

const getReportedUser = (makeCall: MakeCall) => (userId: number) =>
  makeCall<any>('GET', `/api/v2/user/${userId}/report`);

export { getReportedUser };
